// ======================================================================
// File Name       : ContentDrillDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Col, Form, Table } from 'react-bootstrap';
import { CONTENT_DRILL_OBJECT, CONVERT_STATUS, DRILL_TYPE_ID, QUESTION_SELECT_METHOD } from '../../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { getQuestionMethodName, getQuestionListArr, getStartCondition } from '../../utils/ContentUtils';
import { getItemBoxName, htmlEntities } from '../../utils/index';

const ContentDrillDetail = ({ drillDetailInfo, isDetail, questionDrillListArr, markRule }) => {
  if (!drillDetailInfo) {
    return null;
  }
  const questionList = drillDetailInfo.drillGroupArray
    ? getQuestionListArr(drillDetailInfo.drillGroupArray)
    : null;
  const questionListViewAll = questionList
    ? questionList.map((question, index) =>
      (
        <Form.Group key={index}>
          {/* #7154 START */}
          <Col sm={12} className="padding-left-right-clear margin-bottom-10">
            <Col sm={4}>
              <span>問題グループ{++index}</span>
            </Col>
          </Col>
          {/* #7154 END */}
          {parseInt(markRule, 10) === 3 && question.groupPoint && (
            <Col sm={12} className="padding-left-right-clear margin-bottom-10">
              <Col sm={4}>
                <span>点数:&nbsp;{question.groupPoint}</span>
              </Col>
            </Col>
          )}
          {/* STEP10.0.0 START */}
          {question.questionSelectMethod != null && (
            <Col sm={12} className="padding-left-right-clear margin-bottom-10">
              <Col sm={4}>
                <span>出題方法: {getQuestionMethodName(question.questionSelectMethod)}</span>
              </Col>
            </Col>
          )}
          {question.questionSelectMethod === QUESTION_SELECT_METHOD.RANDOM && (
              <Col sm={12} className="padding-left-right-clear margin-bottom-10">
                <Col sm={4}>
                  <span>出題数: {question.questionCount}</span>
                </Col>
              </Col>
          )}
          {/* STEP10.0.0 END */}

          <Col sm={12}>
            <Table striped hover className="table-layout-auto">
              <thead>
                <tr key={index}>
                  <th>問題識別ID</th>
                  {isDetail &&
                    <>
                      <th>問題名</th>
                      <th width='70'>配点</th>
                    </>
                  }
                </tr>
              </thead>
              <tbody>
                {
                  question.questionListTmp.map((questionId, idx) => {
                    const questionDrill = questionDrillListArr && questionDrillListArr.bySecernId
                      && questionDrillListArr.bySecernId[questionId];
                    if (questionDrill) {
                      const { questionTitle, absolutePoint } = questionDrill;
                      return (
                        <tr key={idx}>
                          <td>
                            {questionId}
                          </td>
                          <td>
                            {htmlEntities(questionTitle)}
                          </td>
                          <td>
                            {absolutePoint && `${absolutePoint}点`}
                          </td>
                        </tr>
                      );
                    }
                  })
                }
              </tbody>
            </Table>
          </Col>
        </Form.Group>
      ),
    )
  : null;

  let againLimitNumber = '';
  let againLimit = 0;
  if (drillDetailInfo.againLimit) {
    const againLimitItem = drillDetailInfo.againLimit.split('_');
    if (againLimitItem && againLimitItem.length >= 2) {
      againLimit = againLimitItem[0];
      againLimitNumber = againLimitItem[1];
    }
  }
  let attentionContent = '';
  if (drillDetailInfo && drillDetailInfo.attentionRelateSet) {
    attentionContent = drillDetailInfo.attentionHtmlUse ?
    `[HTML利用] ${drillDetailInfo.attentionZipFileName}` : htmlEntities(drillDetailInfo.attentionContent); // #6818
  }
  const isAdaptiveDrill = drillDetailInfo.drillKind == DRILL_TYPE_ID.ADAPTIVE;
  return (
    <div>
      <Col sm={12}>
        <Form className='form-horizontal'>
          {(drillDetailInfo.convertStatus === CONVERT_STATUS.CONVERSION_ERROR &&
          drillDetailInfo.convertErrorMessage) ?
            <Form.Group className="form-info textColorRed">
              <h3>変換に失敗しました。</h3>
              <h3>{`エラー要因：${drillDetailInfo.convertErrorMessage}`}</h3>
            </Form.Group> : null}
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              ドリル種別
            </Col>
            <Col sm={8} className="padding-top-bottom-10">
              {getItemBoxName(SELECT_BOX_DATA.DRILL_KIND_LIST, drillDetailInfo.drillKind)}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              ドリル識別ID
            </Col>
            <Col sm={8} className="padding-top-bottom-10">
              {drillDetailInfo.drillSecernId || ''}
            </Col>
          </Form.Group>
          <Form.Group className="form-info label-middle">
            <Col sm={4} className="form-label">
              ドリルタイトル
            </Col>
            <Col sm={8} className="padding-top-bottom-10">
              {drillDetailInfo.drillTitle || ''}
            </Col>
          </Form.Group>
          {drillDetailInfo.drillKind !== 4 &&
            <Form.Group className="form-info label-middle">
              <Col sm={4} className="form-label">
                条件付きスタート指定
              </Col>
              <Col sm={8} className="padding-top-bottom-10 white-space-pre-line">
                {getStartCondition(
                  SELECT_BOX_DATA.DRILL_START_CONDITION,
                  drillDetailInfo.startConditionList,
                )}
              </Col>
            </Form.Group>}
          {drillDetailInfo.drillKind !== 4 &&
            <Form.Group className="form-info">
              <Col sm={4} className="form-label">
                再解答回数制限
              </Col>
              <Col sm={8} className="padding-top-bottom-10">
                { (againLimit && againLimitNumber > 0 ) ? `${againLimitNumber}回` : '制限なし' }
              </Col>
            </Form.Group>}
          {drillDetailInfo.drillKind !== 4 &&
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              採点方式
            </Col>
            <Col sm={8} className="padding-top-bottom-10">
              {getItemBoxName(SELECT_BOX_DATA.SCORE_FORM, drillDetailInfo.scoreForm)}
            </Col>
          </Form.Group>}
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              スキンセット
            </Col>
            <Col sm={8} className="padding-top-bottom-10">
              {drillDetailInfo.skinSetName || ''}
            </Col>
          </Form.Group>
        
          {isAdaptiveDrill &&
          <Col>
            <Form.Group>
              <Col sm={4} className="form-label">
              アダプティブドリル最大問題数
              </Col>
              <Col sm={8} className="padding-top-bottom-10">
                {drillDetailInfo.adaptiveDrillMaxQuestionNumber || 0}
              </Col>
            </Form.Group>
          </Col>
          }
          {drillDetailInfo.drillKind !== 4 &&
            <Col>
              <Form.Group className="form-info label-middle">
                <Col sm={4} className="form-label">
                  問題指定
                </Col>
                <Col sm={8} className="padding-top-bottom-10">
                  <Col sm={12} className="padding-left-clear">
                    {questionListViewAll}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info label-middle padding-bottom-10">
                <Col sm={4} className="form-label">
                制限時間
                </Col>
                <Col sm={8}>
                  <Col className="form-label" sm={5}>
                    対象
                  </Col>
                  <Col className="padding-top-bottom-10" sm={7}>
                    {getItemBoxName(
                      SELECT_BOX_DATA.DRILL_LIMIT_TIME_ADAPTED_TARGET,
                      drillDetailInfo.limitTimeAdaptedTarget || 0,
                    )}
                  </Col>
                  {drillDetailInfo.drillLimitTime &&
                  !isNaN(drillDetailInfo.drillLimitTime) && drillDetailInfo.limitTimeAdaptedTarget === CONTENT_DRILL_OBJECT.DRILL_PRIORITY
                    ? <Form.Group className="form-info">
                      {/* #7196 START */}
                      <Col className="form-label" sm={5}>
                        制限時間
                      </Col>
                      {/* #7196 END */}
                      <Col className="padding-top-bottom-10" sm={7}>
                        {`${drillDetailInfo.drillLimitTime} 秒`}
                      </Col>
                    </Form.Group>
                    : null}
                  {drillDetailInfo.limitTimeOverAction && drillDetailInfo.limitTimeAdaptedTarget !== CONTENT_DRILL_OBJECT.DO_NOT_USE
                    ? <Form.Group className="form-info">
                      {/* #7196 START */}
                      <Col className="form-label" sm={5}>
                        タイマー超過時のアクション
                      </Col>
                      {/* #7196 END */}
                      <Col className="padding-top-bottom-10" sm={7}>
                        {getItemBoxName(
                            SELECT_BOX_DATA.LIMIT_TIME_OVER_ACTION,
                            drillDetailInfo.limitTimeOverAction,
                          )}
                      </Col>
                    </Form.Group>
                    : null}
                  {drillDetailInfo.limitTimeCountForm && drillDetailInfo.limitTimeAdaptedTarget !== CONTENT_DRILL_OBJECT.DO_NOT_USE
                    ? <Form.Group className="form-info">
                      <Col className="form-label" sm={5}>
                          カウント方法
                      </Col>
                      <Col className="padding-top-bottom-10" sm={7}>
                        {getItemBoxName(
                            SELECT_BOX_DATA.LIMIT_TIME_COUNT_FORM,
                            drillDetailInfo.limitTimeCountForm || 1,
                          )}
                      </Col>
                    </Form.Group>
                    : null}
                </Col>
              </Form.Group>
              { /* #6582 START */}
              <Form.Group className="form-info label-middle">
                <Col sm={4} className="form-label">
                配点ルール
                </Col>
                <Col sm={8}>
                  <Col className="form-label padding-left-clear" sm={12}>
                    {getItemBoxName(SELECT_BOX_DATA.MARK_RULE, drillDetailInfo.markRule)}
                  </Col>
                  {!isNaN(drillDetailInfo.markRule) && (parseInt(drillDetailInfo.markRule, 10) === 1 || parseInt(drillDetailInfo.markRule, 10) === 2) &&
                  <Col sm={12} className="padding-left-clear">
                    <Col className="form-label padding-left-clear" sm={5}>
                      満点
                    </Col>
                    <Col className="padding-top-bottom-10" sm={7}>
                      {drillDetailInfo.perfectPoint !== null &&
                        !isNaN(drillDetailInfo.perfectPoint)
                        ? `${drillDetailInfo.perfectPoint} 点`
                        : ''}
                    </Col>
                  </Col>
                  }
                </Col>
              </Form.Group>
              <Form.Group className="form-info label-middle">
                <Col sm={4} className="form-label">
                △判定
                </Col>
                <Col sm={8}>
                  <Col className="form-label padding-left-clear" sm={12}>
                    {getItemBoxName(
                      SELECT_BOX_DATA.SANKAKU_JUDGE_USE_SET,
                      drillDetailInfo.sankakuJudgeUseSet || 0,
                    )}
                  </Col>
                  {(!isNaN(drillDetailInfo.sankakuJudgeUseSet) && parseInt(drillDetailInfo.sankakuJudgeUseSet, 10) === 1) &&
                  <Col sm={12} className="padding-left-clear">
                    <Col className="form-label padding-left-clear" sm={5}>
                      部分点付与
                    </Col>
                    <Col className="padding-top-bottom-10" sm={7}>
                      { !isNaN(drillDetailInfo.perfectPoint)
                        ? `${drillDetailInfo.sankakuMarkSet} %`
                        : ''}
                    </Col>
                  </Col>
                  }
                </Col>
              </Form.Group>
              <Form.Group className="form-info label-middle">
                <Col sm={4} className="form-label">
                注意点
                </Col>
                <Col sm={8}>
                  <Col sm={12} className="padding-left-clear">
                    <Col className="form-label padding-left-clear" sm={5}>
                      表示設定
                    </Col>
                    <Col className="padding-top-bottom-10" sm={7}>
                      {getItemBoxName(
                        SELECT_BOX_DATA.ATTENTION_RELATE_SET,
                        drillDetailInfo.attentionRelateSet || 0,
                      )}
                    </Col>
                  </Col>
                  { attentionContent && attentionContent.length ?
                    <Col sm={12} className="padding-left-clear">
                      <Col className="form-label padding-left-clear" sm={5}>
                        内容
                      </Col>
                      <Col className="padding-top-bottom-10" sm={7}>
                        {attentionContent}
                      </Col>
                    </Col> : null
                  }
                </Col>
              </Form.Group>
              { /*#6582 END */}
            </Col>}
        </Form>
      </Col>
    </div>
  );
};
export default ContentDrillDetail;
